import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './i18n/en/common.json';
import enCrm from './i18n/en/crm.json';
import esCommon from './i18n/es/common.json';
import esCrm from './i18n/es/crm.json';
import { safeStorage } from './utils/safeStorage';

const resources = {
  en: {
    common: enCommon,
    crm: enCrm,
  },
  es: {
    common: esCommon,
    crm: esCrm,
  },
};

const supportedLanguages = ['en', 'es'];
const requestedLanguage =
  safeStorage.getItem('simpledealer.language') || navigator.language?.split('-')[0];
const initialLanguage = supportedLanguages.includes(requestedLanguage || '')
  ? requestedLanguage
  : 'en';

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
